
import Component from '../../../assets/scripts/modules/component'
import escapeHTML from '../../../assets/scripts/utilities/escape-html'
import findParentBySelector from '../../../assets/scripts/utilities/find-parent'
import { hydratorRegisterComponent } from '../../../assets/scripts/utilities/hydrator'
import {
  IBAN_INVALID_MESSAGE,
  isIbanFieldName,
  isValidIban,
  normalizeIbanValue
} from '../../../assets/scripts/utilities/iban'

window.onload = function () {
  const firstErrorInput = document.querySelector('.text-field--error input')
  // Do not autofocus fields that already contain a server-rejected value.
  if (firstErrorInput != null && !firstErrorInput.value) {
    firstErrorInput.focus()
  }
}

const CLASSNAME_HAS_VALUE = 'text-field--has-value'
const CLASSNAME_HAS_CHANGED = 'text-field--has-changed'

function showCharacterCount (element, input, format = '%c / %m') {
  function update () {
    current = input.value.length
    display.innerText = format.replace('%c', current).replace('%m', max)
  }

  const display = element.querySelector('[data-role=max-length-display]')

  if (!input || !display) {
    console.log('failed to initialise character counter for', element)
    return
  }

  display.parentNode.classList.add('text-field__wrapper--max-count')

  const max = parseInt(input.getAttribute('maxlength'), 10) || 0
  let current = 0
  element.addEventListener('input', () => update())
  element.addEventListener('change', () => update())
  update()
}

class TextFieldComponent extends Component {
  init () {
    this.input = this.element.querySelector('input, textarea')
    this.initialValue = this.input.value
    this.userInteracted = false
    this.isIbanField = isIbanFieldName(this.input.name)

    // Check initial state and apply class if input has value (e.g., after browser back button)
    if (this.input.value) {
      this.element.classList.add(CLASSNAME_HAS_VALUE)
    }

    // Capture the value that was rejected by server-side validation, so we only
    // clear the error once the user actually changes the input (and not on
    // spurious input events caused by autofocus/autofill).
    this.rejectedValue = this.element.classList.contains('text-field--error') ? this.input.value : null

    // Only clear server-side errors after an explicit user edit interaction.
    this.input.addEventListener('keydown', () => {
      this.userInteracted = true
    })
    this.input.addEventListener('paste', () => {
      this.userInteracted = true
    })
    this.input.addEventListener('drop', () => {
      this.userInteracted = true
    })

    this.input.addEventListener('input', (event) => {
      this.element.classList[event.target.value ? 'add' : 'remove'](CLASSNAME_HAS_VALUE)
      this.element.classList[event.target.value !== this.initialValue ? 'add' : 'remove'](CLASSNAME_HAS_CHANGED)

      if (this.userInteracted && (this.rejectedValue === null || event.target.value !== this.rejectedValue)) {
        this.element.classList.remove('text-field--error')
        this.rejectedValue = null
        if (this.isIbanField) {
          this.input.setCustomValidity('')
        }
      }
    })

    // For auto-growing textarea, taken from https://css-tricks.com/auto-growing-inputs-textareas/
    this.element.querySelector('textarea')?.addEventListener('input', () => {
      this.input.parentNode.dataset.replicatedValue = this.input.value
    })

    const formElement = findParentBySelector(this.element, 'form')
    window.addEventListener('form-error', (event) => {
      const fieldName = this.input.name
      if (event.detail.formElement === formElement && fieldName === event.detail.fieldName) {
        this.showFieldError(event.detail.errors.map(escapeHTML).join('<br>'))
      }
    })

    if (this.isIbanField) {
      this.bindIbanValidation(formElement)
    }

    if (this.input.hasAttribute('maxlength')) {
      showCharacterCount(this.element, this.input)
    }
  }

  showFieldError (messageHtml) {
    this.element.querySelector('[data-role="error"]').innerHTML = messageHtml
    this.element.classList.remove(CLASSNAME_HAS_CHANGED)
    this.element.classList.add('text-field--error')
    this.rejectedValue = this.input.value
  }

  normalizeIbanInput () {
    const normalized = normalizeIbanValue(this.input.value)
    if (normalized !== this.input.value) {
      this.input.value = normalized
      this.element.classList[normalized ? 'add' : 'remove'](CLASSNAME_HAS_VALUE)
    }
  }

  validateIban ({ showError = true } = {}) {
    this.normalizeIbanInput()

    if (!this.input.value.trim() || isValidIban(this.input.value)) {
      this.input.setCustomValidity('')
      return true
    }

    this.input.setCustomValidity(IBAN_INVALID_MESSAGE)
    if (showError) {
      this.showFieldError(escapeHTML(IBAN_INVALID_MESSAGE))
    }
    return false
  }

  bindIbanValidation (formElement) {
    this.input.addEventListener('blur', () => {
      this.validateIban({ showError: Boolean(this.input.value.trim()) })
    })

    if (!formElement) {
      return
    }

    formElement.addEventListener('submit', (event) => {
      const formRow = this.element.closest('.form-row')
      if (formRow && formRow.classList.contains('form-row--hidden')) {
        this.input.setCustomValidity('')
        return
      }

      if (this.validateIban({ showError: true })) {
        return
      }

      event.preventDefault()
      event.stopImmediatePropagation()
      this.input.focus()
    }, true)
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.text-field').forEach(element => {
  element.instance = element.instance || new TextFieldComponent(element)
}))
hydratorRegisterComponent('.text-field', TextFieldComponent)
